
import {
  Component,
  Prop,
  Mixins,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  InputNumber,
} from 'element-ui';
import { ICharge } from '@/types/org.d';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    Button,
    Select,
    Option,
    InputNumber,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '充值',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: ICharge;

  mounted() {
    if (this.title.includes('编辑')) this.form = Object.assign({}, this.oldForm);
    this.form.orgPid = Base64.decode(this.$route.params.pid || '');
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }
}
